module.exports = __webpack_public_path__ + "img/icon-chevron.f0ec6f14.svg";